import React from 'react'

import { Helmet } from 'react-helmet'

import Footer from '../components/footer'
import './redirectioneaza.css'

const Redirectioneaza = (props) => {
  return (
    <div className="redirectioneaza-container1">
      <Helmet>
        <title>Redirectioneaza - @Romania NGO</title>
        <meta
          name="description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta property="og:title" content="Redirectioneaza - @Romania NGO" />
        <meta
          property="og:description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/262a7285-ee36-4827-90cf-bff2da51d3e3/e678668e-577d-45ce-9b60-b935d207ee1c?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/redirectioneaza"
        />
        <meta
          property="og:url"
          content="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/redirectioneaza"
        />
      </Helmet>
      <div className="redirectioneaza-thq-hero-elm">
        <img
          alt="image"
          src="/map.svg"
          className="redirectioneaza-thq-map-elm"
        />
        <img
          alt="image"
          src="/compressed-7100w.gif"
          className="redirectioneaza-thq-gif-elm"
        />
      </div>
      <Footer rootClassName="footerroot-class-name1"></Footer>
    </div>
  )
}

export default Redirectioneaza
